export const ENCOUNTER_AUTOSAVE_DEBOUNCE_MS = 500;
export const BMI_INPUT_DEBOUNCE_MS = 500;
